import React from "react";
import "./MessageCodes.css";

const MessageA4 = (props) => {
  return (
    <div className="a1-wrap" style={{ width: "fit-content" }}>
      <div
        className={
          !props.disable
            ? "chat-label action-tab "
            : "chat-labelnohover action-tab"
        }
        id="main-tab1"
        style={{ color: props.disable && "grey" }}
        onClick={() => {
          if (!props.disable) {
            props.handleClick(props.item.code, null, props.item.text);
            props.setTextOnClick(props.item.text);
          }
        }}
      >
        {props.item.text}
      </div>
    </div>
  );
};

export default MessageA4;
